export class PhoneNumberValidator {
  static readonly errorMessage =
    'Please enter a valid US phone number (e.g. (555) 555-5555, 555-555-5555, or 5555555555)';

  static readonly phoneRegex = /^(\()?\d{3}(\))?[-.\s]?\d{3}[-.\s]?\d{4}$/;

  public validate(value: string): boolean {
    return PhoneNumberValidator.phoneRegex.test(value);
  }
}
